export default "__VITE_ASSET__BTruF7z4__"